"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardPullRequestSortOption = exports.DashboardPullRequestExpandOption = exports.DashboardPullRequestDynamicGroupingOption = exports.DashboardPullRequestWorkStatusGrouping = exports.DashboardPullRequestStaticGroupingOption = exports.DashboardPullRequestStatus = void 0;
const database_types_1 = require("@acumen/database-types");
var PullRequestExtendedStatus;
(function (PullRequestExtendedStatus) {
    PullRequestExtendedStatus["ClosedNotMerged"] = "CLOSED_NOT_MERGED";
})(PullRequestExtendedStatus || (PullRequestExtendedStatus = {}));
// tslint:disable-next-line: variable-name
exports.DashboardPullRequestStatus = { ...database_types_1.AcumenPullRequestStatus, ...PullRequestExtendedStatus };
var DashboardPullRequestStaticGroupingOption;
(function (DashboardPullRequestStaticGroupingOption) {
    DashboardPullRequestStaticGroupingOption["WorkStatus"] = "WorkStatus";
    DashboardPullRequestStaticGroupingOption["WorkStatusOpen"] = "WorkStatusOpen";
    DashboardPullRequestStaticGroupingOption["WorkStatusInReview"] = "WorkStatusInReview";
    DashboardPullRequestStaticGroupingOption["WorkStatusDone"] = "WorkStatusDone";
    DashboardPullRequestStaticGroupingOption["WorkStatusInProgress"] = "WorkStatusInProgress";
})(DashboardPullRequestStaticGroupingOption = exports.DashboardPullRequestStaticGroupingOption || (exports.DashboardPullRequestStaticGroupingOption = {}));
var DashboardPullRequestWorkStatusGrouping;
(function (DashboardPullRequestWorkStatusGrouping) {
    DashboardPullRequestWorkStatusGrouping["Open"] = "Open";
    DashboardPullRequestWorkStatusGrouping["InReview"] = "InReview";
    DashboardPullRequestWorkStatusGrouping["Done"] = "Done";
    DashboardPullRequestWorkStatusGrouping["InReviewProcess"] = "InReviewProcess";
    DashboardPullRequestWorkStatusGrouping["Reviewed"] = "Reviewed";
})(DashboardPullRequestWorkStatusGrouping = exports.DashboardPullRequestWorkStatusGrouping || (exports.DashboardPullRequestWorkStatusGrouping = {}));
var DashboardPullRequestDynamicGroupingOption;
(function (DashboardPullRequestDynamicGroupingOption) {
    DashboardPullRequestDynamicGroupingOption["Highlights"] = "Highlights";
})(DashboardPullRequestDynamicGroupingOption = exports.DashboardPullRequestDynamicGroupingOption || (exports.DashboardPullRequestDynamicGroupingOption = {}));
var DashboardPullRequestExpandOption;
(function (DashboardPullRequestExpandOption) {
    DashboardPullRequestExpandOption["Highlights"] = "Highlights";
})(DashboardPullRequestExpandOption = exports.DashboardPullRequestExpandOption || (exports.DashboardPullRequestExpandOption = {}));
var DashboardPullRequestSortOption;
(function (DashboardPullRequestSortOption) {
    DashboardPullRequestSortOption["OpenedDate"] = "OpenedDate";
    DashboardPullRequestSortOption["UpdatedDate"] = "UpdatedDate";
    DashboardPullRequestSortOption["ClosedDate"] = "ClosedDate";
})(DashboardPullRequestSortOption = exports.DashboardPullRequestSortOption || (exports.DashboardPullRequestSortOption = {}));
//# sourceMappingURL=dashboard-pull-request.js.map